"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useJira_1 = __importDefault(require("hooks/useJira"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ContentModalJira_1 = __importDefault(require("./ContentModalJira"));
const ModalConnectJira = ({ closeCurrentModal, objectiveId, objectiveChildrenCount, currentIntegration, setObjectiveValue, modalType, changeValue }) => {
    const stepModal = (0, useJira_1.default)((state) => state.stepModal);
    const setStepModal = (0, useJira_1.default)((state) => state.setStepModal);
    const isViewChildOnCreate = (0, react_1.useMemo)(() => stepModal == 'child-issues' && modalType != 'import-child', [stepModal, modalType]);
    const closeModalFunc = (0, react_1.useMemo)(() => {
        return isViewChildOnCreate
            ? () => setStepModal('confirm')
            : () => closeCurrentModal();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isViewChildOnCreate]);
    return (react_1.default.createElement(Modal_1.default, { customClass: `cursor-default ${stepModal == 'confirm' ? 'w-[462px]' : 'w-[960px]'}`, onClose: closeModalFunc, minWidth: 462 },
        react_1.default.createElement(ContentModalJira_1.default, { closeCurrentModal: closeCurrentModal, objectiveId: objectiveId, objectiveChildrenCount: objectiveChildrenCount, currentIntegration: currentIntegration, modalType: modalType, setObjectiveValue: setObjectiveValue, changeValue: changeValue })));
};
exports.default = ModalConnectJira;
